import { useMutation } from '@tanstack/react-query';

import { companyApi } from './api';

export const useNotifyCompanyViewMutation = () => {
  const postNotifyCompanyView = async (domain: string) => await companyApi.notifyCompanyView(domain);

  return useMutation({
    mutationKey: ['notify-company-view'],
    mutationFn: postNotifyCompanyView,
  });
};
